<template>
  <div>
    <Row style="width: 100%;margin-top:110px">
		<Col span="24" class="backImg">
			<!-- <img :src="img" width="100%"> -->
			<img v-lazy="img" width="100%">
		</Col>
    </Row> 
   
	<Row style="width: 100%;" class="FontLocal"> 
		<Col span="24" class="title" style="font-size:26px">
			<span >专注四大领域</span><br />
			<span>满足企业数据化应用场景</span> 
		</Col>
	</Row>

	<Row style="display: flex;justify-content: center;margin-top:110px;margin-bottom:60px">
		
		<Col span="5" style="line-height: 30px;margin-left:100px; 
								font-size: 18px;
								width: 20%;
								float: left;
								margin-left: -1%;
								padding: 2% 2%;
								box-shadow: 0px 0px 10px 5px #dcd9ed;
								border: 1px solid #efefef;"><Row style="color: #6a4fe1;letter-spacing: 3px;font-size:22px">      </Row>
				<img v-lazy="img2" width="100%">
				<h2>天然气大数据</h2></br>
				<p style="text-align:left">依托中国科技云-油田领域，积累海量天然气行业数据，解决分散数据的系统依托中国和科学化难题</p></br>
				<router-link to="/gasData">查看更多>></router-link>
		</Col>
		<Col span="5" style="line-height: 30px;margin-left:100px; 
								font-size: 18px;
								width: 20%;
								float: left;
								margin-left: 4%;
								padding: 2% 2%;
								box-shadow: 0px 0px 10px 5px #dcd9ed;
								border: 1px solid #efefef;">
				<img v-lazy="img3" width="100%">
				<h2>汽车大数据产品</h2></br>
				<p style="text-align:left">经过10年以上的汽车大数据经验积淀，研发出一套数据库系统，广泛应用于车险智能风控、二手车估值</p></br>
				<router-link to="/carData">查看更多>></router-link>
		</Col>
		<Col span="5" style="line-height: 30px;margin-left:100px; 
								font-size: 18px;
								width: 20%;
								float: left;
								margin-left: 4%;
								padding: 2% 2%;
								box-shadow: 0px 0px 10px 5px #dcd9ed;
								border: 1px solid #efefef;">
				<img v-lazy="img4" width="100%">
				<h2>声学领域工程</h2></br>
				<p style="text-align:left">依托大数据分析与计算技术国家地方联合工程实验室的优秀资源，将致力于为用户提供专业一流的解决方案， 实行交钥匙工程</p></br>
				<router-link to="/voiceData">查看更多>></router-link>
		</Col>
		<Col span="5" style="line-height: 30px;margin-left:100px; 
								font-size: 18px;
								width: 20%;
								float: left;
								margin-left: 4%;
								padding: 2% 2%;
								box-shadow: 0px 0px 10px 5px #dcd9ed;
								border: 1px solid #efefef;">
				<img v-lazy="img17" width="100%">
				<h2>遥感大数据</h2></br>
				<p style="text-align:left">依托地理空间数据云-遥感领域，汇聚了海量遥感数据成果，可实现一站式地理空间大数据信息服务。</p></br>
				<router-link to="/remoteDigData">查看更多>></router-link>
		</Col>
	</Row>

	<Row style="display: flex;justify-content: center;margin-top:110px;margin-bottom:60px" class="FontLocal">
	<Col span="24" class="title">
		<span style="font-size:26px">北龙泽达用数据驱动未来</span><br />
	</Col>
	</Row>

  	<Row style="margin-top:80px;margin-left:150px">
     
      <Col span="4" style="line-height: 30px;margin-left:100px;
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 20%;
                            float: left;
                            margin-left: -1%;
                            padding: 2% 2%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;"><Row style="color: #6a4fe1;letter-spacing: 3px;font-size:22px">      </Row>
            <img v-lazy="img5" width="80" height="80"></br>
            <h2>大平台下的大数据产业化</h2></br>
            <span>依托大数据分析和计算技术国家地方联合工程实验室的优秀资源，以国家级数据中心服务经验的积累为基础，不断推出云计算、云存储、大数据风控等迭代产品
            </span>
      </Col>
      <Col span="4" style="line-height: 30px;margin-left:100px;
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 20%;
                            float: left;
                            margin-left: 4%;
                            padding: 2% 2%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;">
            <img v-lazy="img6" width="80" height="80"></br>
            <h2>科研的态度洞悉行业数据</h2></br>
            <span>用科研的态度与大数据分析国家地方联合工程实验室紧密结合，分享最新行业数据与科研成果实现产业化运营
            </span></br></br>
      </Col>
       <Col span="4" style="line-height: 30px;margin-left:100px;
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 20%;
                            float: left;
                            margin-left: 4%;
                            padding: 2% 2%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;">
           <img v-lazy="img7" width="80" height="80"></br>
            <h2>专家团队引流数据落地</h2></br>
            <span>强大的专家院士咨询团队保障数据的研究分析，使产品更加专业数据更加准确，资讯更加权威
            </span></br></br></br>
      </Col>
       <Col span="4" style="line-height: 30px;margin-left:100px;
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 20%;
                            float: left;
                            margin-left: 4%;
                            padding: 2% 2%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;">
            <img v-lazy="img8" width="80" height="80"></br>
            <h2>实时更新 随时数据</h2></br>
            <span>随着移动互联网的不断更新，产品报告随时跟随数据更新。不错过每一个商业机会的转瞬即逝，随时掌握行业变化
            </span></br></br>
      </Col>
    </Row>

	<Row style="display: flex;justify-content: center;margin-top:110px;margin-bottom:60px" class="FontLocal">
		<Col span="24" class="title">
			<span style="font-size:26px">解决方案</span><br /><br />
		</Col>
	</Row>

     <Row>
		<Col span="12">
			<img v-lazy="img9" width="100%" style="vertical-align: bottom;">
		</Col>
		<Col span="12" >
			<Row  class="fangan1">
				<Col span="12">
					</br></br></br></br></br></br> </br></br>
					<span style="font-size:22px">天然气行业解决方案</span>
				</Col>
				<Col span="12">
					<img v-lazy="img10" width="100%" style="vertical-align: bottom;">
				</Col>
			</Row>
			<Row>
				<Col span="12">
					<img v-lazy="img11" width="100%" style="vertical-align: bottom;">
				</Col>
				<Col span="12" >
					</br></br></br></br></br></br> </br></br></br></br>
					<span style="font-size:22px;color: #8267f9;">声学应用解决方案</span>
			</Col>
			</Row>
		</Col> 
    </Row>   

	<Row style="display: flex;justify-content: center;margin-top:110px;margin-bottom:60px" class="FontLocal">
		<Col span="24" class="title">
			<span>合作单位</span><br />
		</Col>
	</Row>

    <Row :gutter="25" class="HZImgLocal"> 
        <Col> 
			<div class="connectBanner">
				<div class="backImg">
					<img v-lazy="img16" width="100%" style="vertical-align:bottom;"></br>

				</div>
				<div class="contentBox1 ofhd">
					<div class="content" id="content">
						<video id="video" :src="mv1" autoplay="autoplay" loop="loop" muted="muted" height="93%" width="100%"></video>
						<div>
							</br></br>
							<p class="fontCSS">用数据改变行业观点，引领大数据领域潮流</p>
						</div>
					</div>
				</div>
			</div>
        </Col>
       
    </Row>
  </div>
 
</template>
<script>
export default {
  data() {
    return {
      info:23923,
      bid:115486,
      money:16745305.75,
      noticeList:[],
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      img: "../../../../static/officeImg/index/banner.webp",
      img2:"../../../../static/officeImg/index/areaGas.png",
      img3:"../../../../static/officeImg/index/areacar.png",
      img4:"../../../../static/officeImg/index/areaSound.png",
      img5: "../../../../static/officeImg/index/shuju.png",
      img6:"../../../../static/officeImg/index/keyan.png",
      img7:"../../../../static/officeImg/index/zhuanjiatuanduiguanli.png",
      img8:"../../../../static/officeImg/index/gengxin.png",
      img9:"../../../../static/officeImg/index/01.jpg",
      img10:"../../../../static/officeImg/index/03.jpg",
      img11:"../../../../static/officeImg/index/02.jpg",
      img12:"../../../../static/officeImg/unit/cooperation1.png",
      img13:"../../../../static/officeImg/unit/cooperation2.png",
      img14:"../../../../static/officeImg/unit/cooperation3.png",
      img15:"../../../../static/officeImg/unit/cooperation4.png",
      img16:"../../../../static/officeImg/index/connectBac.webp",
      img17:"../../../../static/officeImg/index/yg.png",
      mv1:"../../../../static/officeImg/index/GeneralIntroduction.mp4"
      // img3: "../../../static/1.jpg",
      // img11: "../../../static/17.jpg",
      // img12: "../../../static/18.jpg"
    };
  },
   filters: {
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, "yyyy-MM-dd hh:mm");
        }
  },
  mounted() {
    this.loadData();
    //千位分割符
     this.money= this.toThousands(this.money,2);
  },
  methods: {
    loadData: function() {
    },
    Goto: function(type,id){
         switch (type) {
          case 'C01':
            {
              this.$router.push({ name: 'detail', query: { detailId: id}})
            }
            break;
          case 'C02':
            {
                this.$router.push({ name: 'detail2', query: { detailId: id}})
            }
            break;
          case 'C03':
            {
                this.$router.push({ name: 'detail1', query: { detailId: id}})
            }
            break;
         case 'C04':
            {
                this.$router.push({ name: 'detail3', query: { detailId: id}})
            }
            break;
            default:
            break;
        }
    },
    more: function() {
      this.$router.push({ path: "/item" });
    },
     //千位分割符
      toThousands: function(num,n, separator) {
     let parts;
     num = num + "";
     // 判断是否为数字
     if (!isNaN(parseFloat(num)) && isFinite(num)) {
    let nx;
         nx=Math.pow(10,n);

         num = (Math.round(num* nx) / nx).toFixed(n);


         parts = num.split('.');
         parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (separator || ','));

         return parts.join('.');
     }
     return NaN;
}
  }
};
</script>
<style scoped> 
.connectBanner .contentBox1 {
	position: absolute;
    width: 660px;
    height: 400px;
    text-align: center;
    padding: 15px;
    top: 70px;
    /* left: 630px;  */
	left: 33%;
}
.bg:hover{
    background: #6a4fe1;
}
.bg1:hover{
    background: #12e123;
}
.backImg {
  background-color: white;
  width: 100%;
  font-size: 25px;
  /* text-align: center; */
  line-height: 30px;
  color: red;
  margin-top: 0px;
  margin-left: 0px;
}
.ImgLocal{
  position:relative;
  left:180px;
  margin-top:40px;
}
.HZImgLocal{
  position:relative;
  /* left:280px; */
  margin-top:40px;
  margin-bottom: 120px;
}
.LYImgLocal{
  position: relative; 
  left:320px;
  margin-top:40px;
  margin-bottom: 120px;
}
.listItem:hover{
	border: #ededed 1px solid;
	box-shadow: 0 1px 6px #e8e8e8;
}
.slider .project_info .title{
	display: block;
	line-height: 85px;
}
.slider .project_info p{
	margin-bottom: 36px;
}
.dataQuDong .sec{
	display:none;
}
.dataQuDong>div:hover .sec{
	display:inline-block;
}
.dataQuDong>div:hover .fir{
	display:none;
	}
.dataQuDong>div:hover{
	background-color:#6a4fe1;
	color:white;
}
.dataQuDong>div:hover p,.dataQuDong>div:hover h4{
	color:white;
}
#btn{ width:100px;height:40px; font-size:20px;border-radius:1110px;
	background:#ff6600; }
#vido{top:0; left:0px;z-index:100}
source{
	width:100%;
}
.connectBanner .contentBox {
	position: absolute;
	text-align: center;
	padding: 15px;
}
.connectBanner .contentBox .content > div {
	position: absolute;
	left: 21%;
	top: 90%;
}
.connectBanner .contentBox .content {
	background: transparent;
	position: relative;
	width: 100%;
	height: 100%;
/* background: transparent;
position: relative;
width: 100%;
height: 100%;
margin-top: -450px;
margin-left: 210px; */
}
.fontCSS {
    text-align: center;
    color: white;
    font-size: 23px;
    line-height: 40px;
    /* padding: 1% 0px; */
    position: absolute;
    /* left: 120px; */
    width: 1040px;
    left: -184px;

}
.FontLocal{
  margin-top:60px;
}
.title {
    text-align: center;
    color: rgb(0, 0, 0);
    font-size: 23px;
    line-height: 40px;
    padding: 1% 0px;
}
.li2 {
  width: 50%;
  font-size: 15px;
  margin-top: 6px;
}
.numInfo {
  background: white;
  font-size: larger;
  font-family: 微软雅黑;
  height: 100px;
  padding: 20px;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
}
.baseCard{
  background: white;
  font-family: 微软雅黑;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
  
}
.cardTitle{
  text-align: left;
  font-weight:540 !important;
  color: orange;
}
.li3 {
  width: 43%;
  font-size: 12px;
}
.icon-shuxian{
 font-size: 20px;
}
.shuxian{
  display:inline-block;
  width:4px;
  height: 22px;
  background: orange;
}
.icon-gengduo{
  color: orange;
}
.gengduo{
  font-family: 微软雅黑;
  color: rgb(120, 122, 123);
  font-size: 15px;
}
.wailian{
  font-size: 15px;
  font-weight:540;
  color:#787a7b;
}
.fangan1{ 
	background-color: #8267f9;
	color: white;
} 
</style>



// WEBPACK FOOTER //
// src/views/indexPage/content.vue